import { useMemo } from 'react';
import { connect } from 'react-redux';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { useWebShare } from 'site-modules/shared/hooks/use-web-share/use-web-share';
import { getShareData } from 'site-modules/inventory/utils/get-share-data';
import PropTypes from 'prop-types';

export const SHARE_CONSTANTS = {
  IMAGE_SRC: '/icons/youtube-share.svg',
  UNSUPPORTED_TITLE: 'Sharing functionality is not supported by your browser.',
};

export const VdpShareUI = ({ year, make, model, children, vin, visitorId, isMobile }) => {
  const shareData = useMemo(
    () => getShareData({ year, make, model, visitorId, isMobile }),
    [year, make, model, visitorId, isMobile]
  );

  const { isSupported, share } = useWebShare(shareData);

  const fireTracking = status => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_SHARE_CONTENT,
        subaction_name: status,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: 'vdp-navigation',
        value: `${vin}`,
      },
    });
  };

  const handleShare = () => {
    fireTracking('share_started');
    share({
      onSuccess: () => fireTracking('share_completed'),
      onError: () => fireTracking('share_failed'),
    });
  };

  return children({
    onShare: handleShare,
    isSupported,
    imageSrc: SHARE_CONSTANTS.IMAGE_SRC,
    title: !isSupported ? SHARE_CONSTANTS.UNSUPPORTED_TITLE : undefined,
  });
};

VdpShareUI.propTypes = {
  children: PropTypes.func.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  vin: PropTypes.string.isRequired,
  visitorId: PropTypes.string,
  isMobile: PropTypes.bool,
};

export const mapStateToProps = state => ({
  visitorId: state?.visitor?.id,
  isMobile: state?.mobile,
});

export const WithVdpShare = connect(mapStateToProps)(VdpShareUI);
